module.exports = __webpack_public_path__ + "img/orange_115.c17545fd.png";